import { COLORS, STATUS } from '@btime/constants'
import React from 'react'

import { useNonCompliance } from '../_load/NonComplianceLoader'
import { useOpenEditActionPlanModal } from '../../../../utils/routes/modals/modalsActions'
import { useSaveActionPlan } from '../../_actions/_requests/saveActionPlan'
import Center from '../../../../components/helpers/Center'
import IconButton from '../../../../components/actions/IconButton'
import Separator from '../../../../components/helpers/Separator'

const ActionPlanButton = () => {
  const item = useNonCompliance()
  const [saveActionPlan] = useSaveActionPlan()
  const openActionPlanCreateModal = useOpenEditActionPlanModal()

  if (item.status !== STATUS.OPEN) return false

  const onClick = () =>
    openActionPlanCreateModal({
      nonComplianceId: item.id,
      placeId: item?.place?.id,
      onSubmit: saveActionPlan
    })

  return (
    <>
      <Separator weight={4} />
      <Center>
        <IconButton label="Novo plano de ação" icon="BsBookmarkPlus" transparent small onClick={onClick} />
      </Center>
    </>
  )
}

export default ActionPlanButton
